import { Badge, BadgeColor } from '@givebutter/primitives/badge';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faArrowTurnDownLeft, faCheck, faTimes } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { PolymorphicTransaction, TransactionFriendlyStatus } from 'types/domain';

interface TransactionStatusBadgeProps {
    transaction: PolymorphicTransaction;
}

const TransactionStatusBadge = (props: TransactionStatusBadgeProps) => {
    const { transaction } = props;
    const { color, icon } = getTransactionStatusProps(transaction?.status_friendly);

    return (
        <Badge color={color}>
            {icon && <FontAwesomeIcon size={'sm'} icon={icon} />}
            {transaction?.status_friendly}
        </Badge>
    );
};

const getTransactionStatusProps = (status: TransactionFriendlyStatus) => {
    let color: BadgeColor = 'neutral';
    let icon: IconDefinition | undefined;

    switch (status) {
        case 'Cancelled':
        case 'Ended':
        case 'Past due failed':
        case 'Disputed':
            color = 'error';
            icon = faTimes;
            break;
        case 'Authorized':
        case 'Pending':
        case 'Paused':
        case 'Past due':
            color = 'warning';
            break;
        case 'Active':
        case 'Succeeded':
            color = 'success';
            icon = faCheck;
            break;
        case 'Refunded':
            icon = faArrowTurnDownLeft;
            break;
        default:
            break;
    }

    return {
        color,
        icon,
    };
};

export { TransactionStatusBadge };
